import { Box, Loader } from "@braintrust/braintrust-ui-components";

export const PublicJobsLoader = () => {
  return (
    <Box sx={{ position: "relative", mt: 6 }}>
      <Loader centered />
    </Box>
  );
};
